import { Alert, Col, Row, Tag, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { ModalItem } from "../../../../Components/Items";
import MapaUbicacionChecada from "../../../../Components/MapaPerimetro/MapaUbicacionChecada";

const formatoFecha = (fecha) => (fecha ? moment(fecha).format("DD/MM/YYYY HH:mm:ss") : "—");

const Dato = ({ titulo, children }) => (
    <div style={{ marginBottom: 6 }}>
        <div style={{ fontSize: 11, color: "#888" }}>{titulo}</div>
        <div style={{ fontSize: 13 }}>{children}</div>
    </div>
);

class ModalUbicacionAsistencia extends Component {
    state = {
        loading: false,
        datos: null,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarUbicacion();
    }
    consultarUbicacion() {
        this.setState({ loading: true, datos: null });
        axios
            .post(
                "asistencias/datosUbicacionAsistencia",
                { empresaId: this.props.empresaId, asistenciaId: this.props.asistenciaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({ loading: false, datos: res.data.data });
                } else {
                    this.setState({ loading: false });
                    message.error(res.data.message || "No se encontró la ubicación de la asistencia");
                }
            });
    }
    render() {
        const { datos } = this.state;
        const precision = datos?.ubicacion?.precision;
        return (
            <ModalItem
                title="Ubicación de la checada"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.props.cerrarUbicacionAsistencia}
                paddingTop
            >
                {datos && (
                    <>
                        {datos.requiereRevision && datos.motivoRevision && (
                            <Alert
                                type="warning"
                                showIcon
                                message="Motivo de revisión"
                                description={datos.motivoRevision}
                                style={{ marginBottom: 10 }}
                            />
                        )}
                        <Row gutter={16}>
                            <Col span={8}>
                                <Dato titulo="Perímetro">{datos.perimetro?.nombre || "—"}</Dato>
                                <Dato titulo="Precisión GPS">
                                    {Number.isFinite(precision) ? `±${Math.round(precision)} m` : "—"}
                                </Dato>
                            </Col>
                            <Col span={8}>
                                <Dato titulo="Hora registrada">{formatoFecha(datos.fechaAsistencia)}</Dato>
                                <Dato titulo="Hora del celular">{formatoFecha(datos.fechaDispositivo)}</Dato>
                            </Col>
                            <Col span={8}>
                                <Dato titulo="Llegó al servidor">{formatoFecha(datos.fechaSincronizacion)}</Dato>
                                <Dato titulo="Conexión">
                                    {datos.offline ? <Tag color="purple">Offline</Tag> : <Tag color="green">En línea</Tag>}
                                </Dato>
                            </Col>
                        </Row>
                        <MapaUbicacionChecada area={datos.perimetro?.area} ubicacion={datos.ubicacion} />
                    </>
                )}
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ModalUbicacionAsistencia);
